module.exports = __webpack_public_path__ + "img/medio10.f02a4009.jpg";